import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, DollarSign, Calendar, Briefcase, FileText, Tag } from 'lucide-react';
import { toast } from 'sonner';
import { Card, CardContent } from '../components/ui/card';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BuyerPayoutDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/buyer/payouts/${id}`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setData(r.data))
      .catch(() => toast.error('Payout not found'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ padding: '60px', textAlign: 'center', color: '#6B7280' }}>Loading...</div>;
  if (!data) return <div style={{ padding: '60px', textAlign: 'center', color: '#6B7280' }}>Not found</div>;
  const p = data.payout;
  const c = data.cycle;
  const statusColors = { PENDING: '#D97706', APPROVED: '#2563EB', PAID: '#059669', VOID: '#6B7280' };
  const sc = statusColors[p.status] || '#6B7280';

  return (
    <div data-testid="buyer-payout-detail-page" style={{ maxWidth: '900px', margin: '0 auto', padding: '32px 24px' }}>
      <button data-testid="payout-detail-back" onClick={() => navigate(-1)}
        style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'none', border: 'none', cursor: 'pointer', color: '#6366F1', fontSize: '14px', fontWeight: 600, marginBottom: '24px' }}>
        <ArrowLeft size={16} /> Back to Payouts
      </button>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
        <h1 data-testid="payout-detail-amount" style={{ fontSize: '28px', fontWeight: 700, color: '#0B0B0B', margin: 0 }}>
          ${Number(p.amount ?? p.amount_usd ?? 0).toFixed(2)} {p.currency}
        </h1>
        <span data-testid="payout-detail-status" style={{ padding: '4px 14px', borderRadius: '20px', fontSize: '12px', fontWeight: 600, background: `${sc}1A`, color: sc }}>{p.status}</span>
      </div>
      <p style={{ fontSize: '13px', color: '#6B7280', marginBottom: '24px' }}>Payout ID: {p.id}</p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', marginBottom: '24px' }}>
        <Card><CardContent className="pt-4 pb-4">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <Briefcase size={14} color="#6366F1" /><span style={{ fontSize: '12px', color: '#6B7280' }}>Portfolio</span>
          </div>
          <p data-testid="payout-detail-portfolio" style={{ fontSize: '14px', fontWeight: 600, color: '#0B0B0B', cursor: 'pointer' }}
            onClick={() => p.portfolio_id && navigate(`/buyer/holdings`)}>{p.portfolio_name}</p>
        </CardContent></Card>
        <Card><CardContent className="pt-4 pb-4">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <Calendar size={14} color="#0EA5E9" /><span style={{ fontSize: '12px', color: '#6B7280' }}>Cycle</span>
          </div>
          <p data-testid="payout-detail-cycle" style={{ fontSize: '14px', fontWeight: 600, color: '#0B0B0B' }}>{p.cycle_name || (c && c.cycle_name) || '-'}</p>
        </CardContent></Card>
        <Card><CardContent className="pt-4 pb-4">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <Tag size={14} color="#10B981" /><span style={{ fontSize: '12px', color: '#6B7280' }}>Method</span>
          </div>
          <p style={{ fontSize: '14px', fontWeight: 600, color: '#0B0B0B' }}>{p.method}</p>
        </CardContent></Card>
        <Card><CardContent className="pt-4 pb-4">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
            <DollarSign size={14} color="#F59E0B" /><span style={{ fontSize: '12px', color: '#6B7280' }}>Currency</span>
          </div>
          <p style={{ fontSize: '14px', fontWeight: 600, color: '#0B0B0B' }}>{p.currency}</p>
        </CardContent></Card>
      </div>

      {c && (
        <Card><CardContent className="pt-5 pb-5">
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
            <FileText size={14} color="#6366F1" />
            <p style={{ fontSize: '13px', fontWeight: 600, color: '#0B0B0B' }}>Cycle Window</p>
          </div>
          <p style={{ fontSize: '13px', color: '#6B7280' }}>
            {new Date(c.start_date).toLocaleDateString()} → {new Date(c.end_date).toLocaleDateString()} · status <strong>{c.status}</strong>
          </p>
        </CardContent></Card>
      )}
    </div>
  );
}
